import { Navigate, Outlet, useParams } from 'react-router';
import styled from 'styled-components';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { SecondaryPageBackground } from '@sorare/core/src/atoms/ui/SecondaryPageBackground';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { ANY_SPORT_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useEnableSorare27Nav } from '@sorare/core/src/hooks/useEnableSorare27Nav';
import { navLabels } from '@sorare/core/src/lib/glossary';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { LineupsModeSwitcher } from '#src/components/boards/LineupsModeSwitcher/index.tsx';

const OVERLAY_MID_COLOR = '#757AEB';

const FullHeightContainer = styled(FullWidthContainer)`
  /* Must track the pinned mode switcher height; the portal renders it outside this subtree. */
  --lineups-bottom-bar-height: calc(var(--unit) * 5);
  @media ${laptopAndAbove} {
    --lineups-bottom-bar-height: calc(var(--unit) * 5 + var(--triple-unit));
    align-content: start;
    min-height: calc(
      var(--100vh) - var(--current-stack-height, 0px) - var(
          --lineups-bottom-bar-height
        )
    );
  }
`;

const ModeSwitcherWrapper = styled.div`
  padding-block-end: var(--double-unit);
  @media ${laptopAndAbove} {
    padding-block-end: var(--triple-unit);
  }
`;

const LineupsLayout = () => {
  const { fixture } = useParams();
  const { generateSportContextPath } = useSportContext();
  const enableSorare27Nav = useEnableSorare27Nav();

  if (!enableSorare27Nav) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_HOME)} replace />;
  }

  return (
    <>
      <PageHeader disableBackBrowser text={navLabels.lineups} />
      <Portal id="shell-background">
        <SecondaryPageBackground overlayMidColor={OVERLAY_MID_COLOR} />
      </Portal>
      <FullHeightContainer>
        <Portal id="above-bottom-bar-portal">
          <ModeSwitcherWrapper>
            <LineupsModeSwitcher fixture={fixture} />
          </ModeSwitcherWrapper>
        </Portal>
        <Outlet />
      </FullHeightContainer>
    </>
  );
};

export default LineupsLayout;
